// Module
var code = `<h2>Loading....</h2>
<programinfo></programinfo>`;
// Exports
export default code;